/**
 * For more information, see the Expo documentation:
 * {@link https://docs.expo.dev/workflow/development-mode/}
 */

export const isDebugMode = (): boolean => __DEV__;
export const isDevEnv = (): boolean =>
  process.env.EXPO_PUBLIC_PROJECT_ID === "lissendev";
export const isProdEnv = (): boolean =>
  process.env.EXPO_PUBLIC_PROJECT_ID === "lissenprod";
export const isPreviewEnv = (): boolean => {
  const lissenEnv = process.env.EXPO_PUBLIC_LISSEN_ENV || "";
  return lissenEnv === "preview" || lissenEnv.startsWith("pr-");
};
export const isLocalEnv = (): boolean => {
  const lissenEnv = process.env.EXPO_PUBLIC_LISSEN_ENV || "";
  return lissenEnv.startsWith("local-");
};
export const shouldSendRemoteTelemetry = (): boolean => !isDebugMode();
